import { Component } from "react";
import { T } from "../styles/GlobalStyles";
import { getErrorMessage } from "../utils/microcopy";
import { logger } from "../utils/logger";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, displayMsg: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error, displayMsg: getErrorMessage("network") };
  }

  componentDidCatch(error, info) {
    logger.error("ErrorBoundary caught", error, { componentStack: info?.componentStack });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 40, textAlign: "center" }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>⚠️</div>
          <div className="condensed" style={{ fontSize: 22, fontWeight: 700, marginBottom: 8, color: T.text }}>
            {this.state.displayMsg}
          </div>
          <div style={{ fontSize: 13, color: T.muted, marginBottom: 20, maxWidth: 400, margin: "0 auto 20px" }}>
            {this.state.error?.message || "Erreur inattendue"}
          </div>
          <button
            onClick={() => {
              this.setState({ hasError: false, error: null, displayMsg: "" });
              window.location.reload();
            }}
            style={{ padding: "10px 20px", borderRadius: 999, background: T.accent, color: T.bg, fontWeight: 700, fontSize: 14 }}
          >
            Recharger
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
